export function SmoothScrollVanilla() {
	const scrollToAnchor = (hash:string) => {
		try{
			const target = document.querySelector(hash) as HTMLElement;
			if (!target) return;

			// const buffer = 0;
			// const header = <HTMLElement>document.querySelector('.js-header');
			// const buffer = matchMedia('(max-width: 767px)').matches ? header.clientHeight;
			const bufferSp: number = 40;
			const bufferPc: number = 80;
			const buffer = matchMedia('(max-width: 768px)').matches ? bufferSp : bufferPc;
			const top = target.getBoundingClientRect().top + window.scrollY - buffer;

			window.scrollTo({
				top,
				behavior: "smooth"
			});

			setTimeout( () => {
				const currentTop = target.getBoundingClientRect().top + window.scrollY - buffer;
				if (top === currentTop) return

				window.scrollTo({
					top: currentTop,
					behavior: "smooth"
				});
			}, 300);
		} catch (error) {
			// console.error('Scroll to anchor error:', error);
		}
	}

	const anchors = document.querySelectorAll('a[href^="#"]');
	//URLのハッシュ値を取得
	const urlHash = location.hash;
	//ハッシュ値があればページ内スクロール
	if(urlHash) {
		setTimeout( () => {
			scrollToAnchor(urlHash);
		}, 300);
	}

	anchors.forEach(anchor => {
		anchor.addEventListener('click', e => {
			e.preventDefault();
			const href = anchor.getAttribute('href');
			if (href === null) return;
			const hash = href === '#' || href === '' ? '#top' : href;

			scrollToAnchor(hash);
		});
	});
}
